export default __webpack_public_path__ + "static/media/pixel5-bg.c60b58c5.webp";